import moment from 'moment';
import { getReports } from '../../fetch';

const { default: store } = require('../../store');

export default async function updateFlightList(result) {
  const reportTrips = store.getState().reportTrips.items;
  const responseTrip = await getReports(
    'trips',
    result.deviceId,
    0,
    0,
    moment(result.startTime).toISOString(),
    moment(result.endTime).toISOString(),
    false
  );
  if (responseTrip.ok) {
    const resultTrip = await responseTrip.json();
    const newReportTrips = reportTrips.map((item) =>
      item.startTime === result.startTime &&
      item.endTime === result.endTime &&
      item.deviceId === result.deviceId
        ? resultTrip.find(
            (trip) =>
              trip.startTime === result.startTime &&
              trip.endTime === result.endTime &&
              trip.deviceId === result.deviceId
          )
        : item
    );
    return newReportTrips;
  }

  return reportTrips;
}
